import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import Config from 'modules/config';

export default class DisplayLegacyOnboardingEntry extends React.Component {
  static propTypes = {
    legacyQuestionnaire: PropTypes.string.isRequired,
  };
  state = {
    showLegacy: false,
  };

  displayInfo = () => (
    <div>
      <div>{ReactHtmlParser(this.props.legacyQuestionnaire)}</div>
    </div>
  );
  render() {
    // console.devLog.info('legacy props:', this.props);
    return (
      <div className="d-flex justify-center flex-column d-flex-column align-center align-items-center mb-2">
        <h3>
          {Config.IS_TRAINER_APP
            ? `Existing Trainerize Data Found`
            : `You've got existing data from Trainerize!`}
        </h3>
        <p>
          {Config.IS_TRAINER_APP
            ? `Client has legacy trainerize data, if they did the document a button will appear below`
            : `This questionnaire is not required for you, but you can fill it in if
          you'd like to get up-to-date information into your profile here.`}
        </p>

        {this.props.legacyQuestionnaire !== '' && (
          <button
            className="btn btn-outline-primary ml-2 mr-2"
            onClick={() =>
              this.setState((prevState) => ({
                showLegacy: !prevState.showLegacy,
              }))
            }
          >
            {this.state.showLegacy ? 'Hide Legacy Info' : 'Show Legacy Info'}
          </button>
        )}
        {this.state.showLegacy && this.displayInfo()}
      </div>
    );
  }
}
